import { BFormTimepicker } from './form-timepicker';
import { pluginFactory } from '../../utils/plugins';
var FormTimepickerPlugin = /*#__PURE__*/pluginFactory({
  components: {
    BFormTimepicker: BFormTimepicker,
    BTimepicker: BFormTimepicker
  }
});
export { FormTimepickerPlugin, BFormTimepicker };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/form-timepicker/index.js
// module id = 213
// module chunks = 0